import React from 'react';
import PropTypes from 'prop-types';
import s from './ImageRichText.module.scss';
import Image from '../Image';
import Richtext from '../Richtext/Richtext';

const ImageRichText = ({ image, text }) => {
    return (
        <div className={s.Root}>
            <div className={s.Container}>
                {image && (
                    <div className={s.Image}>
                        <Image useCover={false} useCaption={false} {...image} />
                    </div>
                )}
                {text && <Richtext text={text} modifier="ImageRichText" />}
            </div>
        </div>
    );
};

ImageRichText.propTypes = {};

export default ImageRichText;
